<template>
    <div class="checkbox" @click="actionToggleChecked">
        <div class="checkbox-mark" :class="classes">
            <img v-if="checked" src="../../assets/images/check-icon-white.svg" alt="">
            <img class="checkbox-grey" src="../../assets/images/check-icon-grey.svg" alt="">
        </div>
    </div>
</template>

<script>
    export default {
        name: "Checkbox",
        props: {
            initChecked: {
                type: Boolean,
                default: false,
            },
        },
        computed: {
            classes() {
                return {
                    'checked': this.checked,
                }
            }
        },
        data() {
            return {
                checked: this.initChecked,
            }
        },
        methods: {
            actionToggleChecked() {
                this.checked = !this.checked;
                this.$emit('change', this.checked);
            }
        },
        watch: {
            initChecked(value) {
                this.checked = value;
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../scss/variables";

    .checkbox {
        .checkbox-mark {
            width: 16px;
            height: 16px;
            border-radius: $s-border-radius;
            background-color: $bg-color-2;
            cursor: pointer;

            & > img {
                height: 100%;
            }

            & > .checkbox-grey {
                visibility: hidden;
                opacity: 0;
            }

            &:hover {
                &:not(.checked) {
                    & > .checkbox-grey {
                        visibility: visible;
                        opacity: 1;
                    }
                }
            }

            &.checked {
                background-color: $main-color;
            }
        }

    }
</style>